import React, { Component } from 'react';
import { connect } from "react-redux";
import ethereum from 'decentralized/ethereum.js';
import FolderComponent from './FolderComponent.js';
import '../../Folders.scss';

class FoldersComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };

        this.loadFolders();
    }

    async loadFolders() {
        if (!ethereum.folders.isLoaded) {
            await ethereum.folders.loadFolders();
            this.setState(this.state);
        }
    }

    get selectedFolder() {
        return this.props.sequencerEngine.state.presets.selectedFolder;
    }

    onKeyUp(e) {
        console.log('on key up = ' + e.key);
        e.stopPropagation();
        if (e.key === 'Delete') {
            this.selectedFolder.delete();
        }
        return false;
    }

    render() {
        let root = ethereum.folders.root;
        let subFolders = root.subFolders;
        subFolders.sort((a, b) => {
            if (a.name === undefined || b.name === undefined) {
                return 0;
            }
            return a.name.localeCompare(b.name);
        });
 
        return (
            <div
              className="folders-container">
              {subFolders.map(
                  (folder, i) => 
                      <FolderComponent
                            key={folder.name+'-'}
                            onFoldersUpdated={() => this.setState(this.state)}
                            onChooseItem={this.props.onChooseItem}
                            onChooseFolder={this.props.onChooseFolder}
                            onTestItem={this.props.onTestItem}
                            showItems={this.props.showItems}
                            folder={folder}
                        />)}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
    }
};

export default connect(mapStateToProps, null)(FoldersComponent);


